import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { GridFilterSelectMultiple } from './GridFilterSelectMultiple';
import { UserState } from '@api/models/enums/UserState';

const options = Object.values(UserState);

interface Props {
  value?: UserState[];
  onChange: (values?: UserState[]) => void;
}

export const GridFilterSupplierEmployeeState: FC<Props> = ({
  value,
  onChange,
}) => {
  const { t } = useTranslation();

  return (
    <GridFilterSelectMultiple
      value={value ?? []}
      options={options}
      onChange={onChange}
      getOptionId={(option: UserState) => option}
      getOptionName={(option: UserState) => t(`entityState.${option}`)}
    />
  );
};
